import { app } from '../../../../../../app';
import { Controller } from './delete-accounts.controller';

app.component('companyUserDirectoriesDirectoryGroupsAllAccountsDelete', {
    bindings: {
        accounts: '<',
        companyId: '<',
        selectedAccounts: '<',
    },
    controller: Controller,
    templateUrl: require('./delete-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/all-accounts/delete/delete-accounts.component.js